import React, { useState, useEffect } from "react";
import { HttpGet } from "../../providers/HttpClient";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import VehicleTab from "./LogVehicleList";
import ProductTab from "./LogProductList";

const LogBookPage: React.FC = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<"product" | "vehicle">("vehicle");
  const [datas, setDatas] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [productDatas, setProductDatas] = useState<any>([]);
  const [pageProduct, setPageProduct] = useState(0);
  const [hasMoreProduct, setHasMoreProduct] = useState(true);
  const [companyProfile, setCompanyProfile] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile"))
  );

  // State untuk filter
  const [vehicleFilters, setVehicleFilters] = useState<any>({});
  const [productFilters, setProductFilters] = useState<any>({});

  const formatDateForAPI = (dateString: string) => {
    if (!dateString) return "";
    // Jika sudah ada waktu, format langsung. Jika tidak, tambahkan waktu default
    const hasTime = dateString.includes(":");
    if (hasTime) {
      return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
    }
    // Untuk date input tanpa waktu, tambahkan waktu
    return moment(dateString).format("YYYY-MM-DD 00:00:00");
  };

  const buildQueryParams = (filters: any, page: number) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("size", "10");

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        // Format tanggal jika key mengandung 'Date'
        if (key.toLowerCase().includes("date")) {
          const formattedDate = formatDateForAPI(filters[key]);
          if (formattedDate) {
            params.append(key, formattedDate);
          }
        } else {
          params.append(key, filters[key]);
        }
      }
    });

    return params.toString();
  };

  const getDatasVehicle = async (pageNumber: number, filters: any = {}) => {
    const queryParams = buildQueryParams(
      { ...filters, sort: "updateTime", dir: "-1" },
      pageNumber
    );

    await HttpGet(`member/log_vehicle?${queryParams}`).then((res: any) => {
      const newData = res.data.content;

      if (newData.length < 10) {
        setHasMore(false);
      }
      setDatas((prev: any[]) =>
        pageNumber === 0 ? newData : [...prev, ...newData]
      );
    });
  };

  const getDatasProduct = async (pageNumber: number, filters: any = {}) => {
    const queryParams = buildQueryParams(
      { ...filters, sort: "createTime", dir: "-1" },
      pageNumber
    );

    await HttpGet(`member/log_product?${queryParams}`).then((res: any) => {
      const newData = res.data.content;

      if (newData.length < 10) {
        setHasMoreProduct(false);
      }

      setProductDatas((prev: any[]) =>
        pageNumber === 0 ? newData : [...prev, ...newData]
      );
    });
  };

  const handleLoadMore = () => {
    if (hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const handleLoadMoreProduct = () => {
    if (hasMoreProduct) {
      setPageProduct((prev) => prev + 1);
    }
  };

  const handleVehicleFilter = (filters: any) => {
    setVehicleFilters(filters);
    setPage(0);
    setHasMore(true);
    setDatas([]);
  };

  const handleVehicleReset = () => {
    setVehicleFilters({});
    setPage(0);
    setHasMore(true);
    setDatas([]);
  };

  const handleProductFilter = (filters: any) => {
    setProductFilters(filters);
    setPageProduct(0);
    setHasMoreProduct(true);
    setProductDatas([]);
  };

  const handleProductReset = () => {
    setProductFilters({});
    setPageProduct(0);
    setHasMoreProduct(true);
    setProductDatas([]);
  };

  useEffect(() => {
    if (activeTab === "vehicle") {
      getDatasVehicle(page, vehicleFilters);
    }
  }, [page, activeTab, vehicleFilters]);

  useEffect(() => {
    if (activeTab === "product") {
      getDatasProduct(pageProduct, productFilters);
    }
  }, [pageProduct, activeTab, productFilters]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header
        style={{ backgroundColor: companyProfile?.color }}
        className="text-white p-4 rounded-b-xl shadow"
      >
        <h1 className="text-2xl font-bold">Log Book</h1>
        <p className="text-sm opacity-80">Sistem Pencatatan Keluar Masuk</p>
      </header>

      {/* Tabs */}
      <div className="flex mt-4 bg-white rounded-lg mx-4 shadow overflow-hidden">
        <button
          onClick={() => setActiveTab("product")}
          className={`flex-1 py-3 flex items-center justify-center gap-2 font-medium transition ${
            activeTab === "product"
              ? `text-white`
              : "text-gray-700 hover:bg-gray-100"
          }`}
          style={{
            backgroundColor:
              activeTab === "product" ? companyProfile?.color : undefined,
          }}
        >
          Barang
        </button>
        <button
          onClick={() => setActiveTab("vehicle")}
          className={`flex-1 py-3 flex items-center justify-center gap-2 font-medium transition ${
            activeTab === "vehicle"
              ? `text-white`
              : "text-gray-700 hover:bg-gray-100"
          }`}
          style={{
            backgroundColor:
              activeTab === "vehicle" ? companyProfile?.color : undefined,
          }}
        >
          Kendaraan
        </button>
      </div>

      {/* TAB CONTENT */}
      {activeTab === "vehicle" && (
        <VehicleTab
          datas={datas}
          hasMore={hasMore}
          handleLoadMore={handleLoadMore}
          onFilter={handleVehicleFilter}
          onReset={handleVehicleReset}
        />
      )}
      {activeTab === "product" && (
        <ProductTab
          datas={productDatas}
          hasMore={hasMoreProduct}
          handleLoadMore={handleLoadMoreProduct}
          onFilter={handleProductFilter}
          onReset={handleProductReset}
        />
      )}
    </div>
  );
};

export default LogBookPage;
